import React from 'react'
import { DDISelectField } from 'ddiForm/wrapped'
import memoize from 'memoize-one'
import { maxLength } from 'ddiForm/validations'

const states = [
  {
    description: 'Alabama',
    dataId: 'AL'
  },
  {
    description: 'Alaska',
    dataId: 'AK'
  },
  {
    description: 'Arizona',
    dataId: 'AZ'
  },
  {
    description: 'Arkansas',
    dataId: 'AR'
  },
  {
    description: 'California',
    dataId: 'CA'
  },
  {
    description: 'Colorado',
    dataId: 'CO'
  },
  {
    description: 'Connecticut',
    dataId: 'CT'
  },
  {
    description: 'Delaware',
    dataId: 'DE'
  },
  {
    description: 'District Of Columbia',
    dataId: 'DC'
  },
  {
    description: 'Florida',
    dataId: 'FL'
  },
  {
    description: 'Georgia',
    dataId: 'GA'
  },
  {
    description: 'Hawaii',
    dataId: 'HI'
  },
  {
    description: 'Idaho',
    dataId: 'ID'
  },
  {
    description: 'Illinois',
    dataId: 'IL'
  },
  {
    description: 'Indiana',
    dataId: 'IN'
  },
  {
    description: 'Iowa',
    dataId: 'IA'
  },
  {
    description: 'Kansas',
    dataId: 'KS'
  },
  {
    description: 'Kentucky',
    dataId: 'KY'
  },
  {
    description: 'Louisiana',
    dataId: 'LA'
  },
  {
    description: 'Maine',
    dataId: 'ME'
  },
  {
    description: 'Maryland',
    dataId: 'MD'
  },
  {
    description: 'Massachusetts',
    dataId: 'MA'
  },
  {
    description: 'Michigan',
    dataId: 'MI'
  },
  {
    description: 'Minnesota',
    dataId: 'MN'
  },
  {
    description: 'Mississippi',
    dataId: 'MS'
  },
  {
    description: 'Missouri',
    dataId: 'MO'
  },
  {
    description: 'Montana',
    dataId: 'MT'
  },
  {
    description: 'Nebraska',
    dataId: 'NE'
  },
  {
    description: 'Nevada',
    dataId: 'NV'
  },
  {
    description: 'New Hampshire',
    dataId: 'NH'
  },
  {
    description: 'New Jersey',
    dataId: 'NJ'
  },
  {
    description: 'New Mexico',
    dataId: 'NM'
  },
  {
    description: 'New York',
    dataId: 'NY'
  },
  {
    description: 'North Carolina',
    dataId: 'NC'
  },
  {
    description: 'North Dakota',
    dataId: 'ND'
  },
  {
    description: 'Ohio',
    dataId: 'OH'
  },
  {
    description: 'Oklahoma',
    dataId: 'OK'
  },
  {
    description: 'Oregon',
    dataId: 'OR'
  },
  {
    description: 'Palau',
    dataId: 'PW'
  },
  {
    description: 'Pennsylvania',
    dataId: 'PA'
  },
  {
    description: 'Rhode Island',
    dataId: 'RI'
  },
  {
    description: 'South Carolina',
    dataId: 'SC'
  },
  {
    description: 'South Dakota',
    dataId: 'SD'
  },
  {
    description: 'Tennessee',
    dataId: 'TN'
  },
  {
    description: 'Texas',
    dataId: 'TX'
  },
  {
    description: 'Utah',
    dataId: 'UT'
  },
  {
    description: 'Vermont',
    dataId: 'VT'
  },
  {
    description: 'Virginia',
    dataId: 'VA'
  },
  {
    description: 'Washington',
    dataId: 'WA'
  },
  {
    description: 'West Virginia',
    dataId: 'WV'
  },
  {
    description: 'Wisconsin',
    dataId: 'WI'
  },
  {
    description: 'Wyoming',
    dataId: 'WY'
  }
]

const statesAndProvinces = [
  ...states,
  {
    description: 'Alberta',
    dataId: 'AB'
  },
  {
    description: 'British Columbia',
    dataId: 'BC'
  },
  {
    description: 'Manitoba',
    dataId: 'MB'
  },
  {
    description: 'New Brunswick',
    dataId: 'NB'
  },
  {
    description: 'Newfoundland and Labrador',
    dataId: 'NL'
  },
  {
    description: 'Northwest Territories',
    dataId: 'NT'
  },
  {
    description: 'Nova Scotia',
    dataId: 'NS'
  },
  {
    description: 'Nunavut',
    dataId: 'NU'
  },
  {
    description: 'Ontario',
    dataId: 'ON'
  },
  {
    description: 'Prince Edward Island',
    dataId: 'PE'
  },
  {
    description: 'Quebec',
    dataId: 'QC'
  },
  {
    description: 'Saskatchewan',
    dataId: 'SK'
  },
  {
    description: 'Yukon Territory',
    dataId: 'YT'
  }
]

const StateSelectField = memoize(
  ({
    propertyName = 'state',
    validate = maxLength(2),
    values = statesAndProvinces,
    label = 'State',
    selectValue = 'dataId',
    selectDescription = 'description',
    style = {},
    ...rest
  }) => (
    <DDISelectField
      propertyName={propertyName}
      values={values}
      selectValue={selectValue}
      selectDescription={selectDescription}
      label={label}
      validate={validate}
      style={style}
      {...rest}
    />
  )
)

export default StateSelectField
